import { createAction, props } from '@ngrx/store';

const actionKey = '[Application settings]';

export const loadApplicationSettings = createAction(`${actionKey} load application settings`);
export const loadApplicationSettingsSuccess = createAction(
  `${actionKey} load application settings success`,
  props<{ applicationSettings }>(),
);
export const loadApplicationSettingsFailed = createAction(
  `${actionKey} load application settings failed`,
);

export const loadCacheOptions = createAction(`${actionKey} load cache options`);
export const loadCacheOptionsSuccess = createAction(
  `${actionKey} load cache options success`,
  props<{ cacheOptions }>(),
);
export const loadCacheOptionsFailed = createAction(`${actionKey} load cache options failed`);

export const setCacheOption = createAction(
  `${actionKey} set cache size`,
  props<{ optionId: number }>(),
);
export const setCacheOptionSuccess = createAction(
  `${actionKey} set cache size success`,
  props<{ optionId: number }>(),
);
export const setCacheOptionFailed = createAction(`${actionKey} set cache size failed`);

export const setWifiOnly = createAction(
  `${actionKey} set wify only`,
  props<{ wifiOnly: boolean }>(),
);
export const setWifiOnlySuccess = createAction(
  `${actionKey} set wify only success`,
  props<{ wifiOnly: boolean }>(),
);
export const setWifiOnlyFailed = createAction(`${actionKey} set wify only failed`);

export const setOfflinePlayback = createAction(
  `${actionKey} set offline playback`,
  props<{ isOfflineCacheEnabled: boolean }>(),
);
export const setOfflinePlaybackSuccess = createAction(
  `${actionKey} set offline playback success`,
  props<{ isOfflineCacheEnabled: boolean }>(),
);
export const setOfflinePlaybackFailed = createAction(`${actionKey} set offline playback failed`);

export const clearCache = createAction(`${actionKey} clear cache`);
export const cearCacheSuccess = createAction(`${actionKey} clear cache success`);
export const clearCacheFailed = createAction(`${actionKey} clear cache failed`);

export const refreshCacheSize = createAction(`${actionKey} refresh cache size`);
export const refreshCacheSizeSuccess = createAction(
  `${actionKey} refresh cache size success`,
  props<{ cacheSize: number }>(),
);
export const refreshCacheSizeFailed = createAction(`${actionKey}  refresh cache size failed`);
